import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";

const service = new Service();

export const GetListHotNews = (data) => {
  const params = new URLSearchParams();
  params.append("pageIndex", data.pageIndex);
  params.append("pageSize", data.pageSize);

  data.id && params.append("id", data.id);
  data.title && params.append("title", data.title);
  data.categoryId && params.append("categoryId", data.categoryId);
  data.image_Url && params.append("image_Url", data.image_Url);
  data.name && params.append("name", data.name);
  data.status && params.append("status", data.status);
  data.description && params.append("description", data.description);
  data.content && params.append("content", data.content);
  data.createdDate && params.append("createdDate", data.createdDate);
  data.modifiedDate && params.append("modifiedDate", data.modifiedDate);

  return service
      .get(ApiUrl.GetListHotNews, params)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
};

export const SearchNews = (data) => {
  const params = new URLSearchParams();
  params.append("pageIndex", data.pageIndex);
  params.append("keyword", data.keyword);
  params.append("pageSize", data.pageSize);

  data.id && params.append("id", data.id);
  data.title && params.append("title", data.title);
  data.categoryId && params.append("categoryId", data.categoryId);
  data.image_Url && params.append("image_Url", data.image_Url);
  data.name && params.append("name", data.name);
  data.status && params.append("status", data.status);
  data.description && params.append("description", data.description);
  data.content && params.append("content", data.content);
  data.createdDate && params.append("createdDate", data.createdDate);
  data.modifiedDate && params.append("modifiedDate", data.modifiedDate);

  return service
      .get(ApiUrl.SearchNews, params)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
};

export const GetListNews = (data) => {
  const params = new URLSearchParams();
  params.append("pageIndex", data.pageIndex);
  params.append("pageSize", data.pageSize);

  data.id && params.append("id", data.id);
  data.title && params.append("title", data.title);
  data.categoryId && params.append("categoryId", data.categoryId);
  data.image_Url && params.append("image_Url", data.image_Url);
  data.name && params.append("name", data.name);
  data.status && params.append("status", data.status);
  data.description && params.append("description", data.description);
  data.content && params.append("content", data.content);
  data.createdDate && params.append("createdDate", data.createdDate);
  data.modifiedDate && params.append("modifiedDate", data.modifiedDate);
  data.keyword && params.append("keyword", data.keyword);

  return service
      .get(ApiUrl.GetListNews, params)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
};

export const GetDetailNews = (id) => {
  let requestUrl = ApiUrl.GetDetailNews + '/' +id;

  return service
    .get(requestUrl)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const GetDetailFormTemplate = (id) => {
  const params = new URLSearchParams();
  params.append("NewsId", id);

  return service
    .get(ApiUrl.GetDetailFormTemplate, params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const CreateFeedback = (data) => {
  return service
    .post(ApiUrl.CreateFeedback, data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const GetListExpiredForm = (data) => {
  const params = new URLSearchParams();
  params.append("pageIndex", data.pageIndex);
  params.append("pageSize", data.pageSize);
  data.sortExpression && params.append("sortExpression", data.sortExpression);
  data.title && params.append("title", data.title);
  data.NewsId &&
    params.append("NewsId", data.NewsId);

  return service
    .get(ApiUrl.GetListExpiredForm, params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const GetReportFeedback = (id) => {
  const params = new URLSearchParams();
  params.append("templateId", id);

  return service
    .get(ApiUrl.GetReportFeedback, params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
